import React, { Component } from "react";
import { motion } from "framer-motion";
import MenuBar from "../../layouts/MenuBar";
import Footer from "../../layouts/Footer";
import { connect } from "react-redux";
import bizd from "../../assets/img/Turbnew.jpg";
import biz from "../../assets/img/Turbnew.jpg";
import { toast, ToastContainer } from "react-toastify";
import { Turboaction } from "../../state-management/actions/auth/TurboActions";
import PropTypes from "prop-types";
import { getCountries } from "../../state-management/actions/location/location-action";

const inputClass =
  "w-full rounded-lg border border-gray-300 px-3 py-2.5 text-[15px] transition-colors focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-brand-teal";
const labelClass = "mb-1 block text-sm font-medium text-brand-dark/80";

class Turbos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first: "",
      last: "",
      address: "",
      email: "",
      alternateEmail: "",
      phone: "",
      country: "",
      state: "",
      alternatePhone: "",
      referral: "",
      passsword: "",
      plan: this.props.location.state
        ? this.props.location.state.plan
        : "Tizeti Turbo Connect",

      planName: this.props.location.state
        ? this.props.location.state.planName
        : "turbo_connect",

      amount: this.props.location.state
        ? this.props.location.state.amount
        : "76000",

      about: "",
      source: "",
      phoneError: "",
      terms: false,
      payment_option: "paystack",
    };
  }

  static propTypes = {
    load: PropTypes.bool.isRequired,
  };

  plans = {
    turbo_connect: {
      plan: "Tizeti Turbo Connect",
      amount: "76000",
    },

    turbo_connect_pro: {
      plan: "Tizeti Turbo Connect Pro",
      amount: "120000",
    },
  };

  Turboaction = (e) => {
    e.preventDefault();

    const {
      first,
      last,
      address,
      email,
      phone,
      source,
      payment_option,
      amount,
      country,
      state,
      referral,
      planName,
    } = this.state;
    const data = {
      firstName: first,
      lastName: last,
      address,
      email,
      phoneNumber: phone,
      language: "english",
      country,
      referral,
      state,
      allowEmail: true,
      plan: planName,
      about_us: source,
      payment_option,
    };
    const numbers = /^[0-9]+$/;
    if (!phone.match(numbers)) {
      toast.info("Please enter only numbers");
    } else if (phone.length !== 11) {
      toast.info("invalid phone number");
    } else {
      this.props.Turboaction(data, amount, this.props.history);
    }
  };

  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
    });
  handlePlanChange = (e) => {
    const selectedPlan = e.target.value;

    this.setState({
      planName: selectedPlan,
      plan: this.plans[selectedPlan].plan,
      amount: this.plans[selectedPlan].amount,
    });
  };

  handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    this.setState({
      [name]: type === "checkbox" ? checked : value,
    });
  };

  handleNumber = (e) => {
    const { name, value } = e.target;
    if (isNaN(Number(value))) return;
    this.setState({ [name]: value });
  };

  handleSpaceBar = (e) => {
    if (e.keyCode === 32) e.preventDefault();
  };
  submitForm() {
    const { first, last, address, email, phone, terms, country, state } =
      this.state;
    return (
      first.length > 0 &&
      last.length > 0 &&
      address.length > 0 &&
      email.length > 0 &&
      state.length > 0 &&
      country.length > 0 &&
      phone.length === 11 &&
      terms
    );
  }

  componentDidMount() {
    this.props.getCountries();

    const { referralId } = this.props.match.params;

    if (referralId) {
      this.setState({
        referral: referralId,
      });
    }
  }

  displayStateAndRegions = () => {
    if (this.state.country === "gh") {
      return this.props.countries
        .filter((country) => country.country === "Ghana")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else if (this.state.country === "cv") {
      return this.props.countries
        .filter((country) => country.country === "Cote d'Ivoire")
        .map((state) => <option value={state.state}>{state.state}</option>);
    } else {
      return this.props.countries
        .filter((country) => country.country === "Nigeria")
        .map((state) => <option value={state.state}>{state.state}</option>);
    }
  };

  render() {
    const { load, location } = this.props;
    const isEnabled = this.submitForm();

    const { first, last, address, email, phone, terms } = this.state;
    return (
      <div>
        <MenuBar />
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto px-4 pt-8 text-center"
        >
          {location.state ? (
            <>
              <h1 className="text-3xl md:text-4xl font-extrabold text-brand-dark">
                {this.state.plan}
              </h1>
              <p className="mt-3 text-gray-600 leading-relaxed">
                The Next Generation of our Unlimited Internet,{" "}
                {location.state.plan} will provide data and voice services to
                Enterprise Business District, Estate, Multi-Story Building, and
                Housing Complex. Tizeti proposes providing a wireless network
                solution for your organization in the following capacity;
                Digital landline Telephone, Surveillance, Internet Service etc.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-3xl md:text-4xl font-extrabold text-brand-dark">
                {this.state.plan}
              </h1>
              <p className="mt-3 text-gray-600 leading-relaxed">
                The Next Generation of our Unlimited Internet, Tizeti Turbo
                Connect will provide data and voice services to Enterprise
                Business District, Estate, Multi-Story Building, and Housing
                Complex. Tizeti proposes providing a wireless network solution
                for your organization in the following capacity; Digital
                landline Telephone, Surveillance, Internet Service etc.
              </p>
            </>
          )}
          <img
            className="w-full mt-6 rounded-2xl shadow-lg"
            alt={this.state.plan}
            src={
              location.state
                ? location.state.planName === "turbo_connect"
                  ? bizd
                  : biz
                : bizd
            }
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="max-w-md mx-auto px-4 my-12"
        >
          <form
            className="rounded-2xl bg-white p-6 md:p-8 shadow-[0px_15px_35px_0px_rgba(0,0,0,0.08)] border border-black/5"
            onSubmit={this.Turboaction}
          >
            <div className="text-left space-y-4">
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className={labelClass}>First Name</label>
                  <input
                    type="text"
                    name="first"
                    value={first}
                    onChange={this.onChange}
                    className={inputClass}
                    placeholder="First Name"
                  />
                </div>

                <div className="flex-1">
                  <label className={labelClass}>Last Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    name="last"
                    value={last}
                    onChange={this.onChange}
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div>
                <label className={labelClass}>Phone Number</label>
                <input
                  type="tel"
                  pattern="0[789]{1}[01]{1}[0-9]{8}"
                  title="Please enter your valid 11-digit phone number"
                  className={inputClass}
                  name="phone"
                  value={phone}
                  maxLength="11"
                  placeholder="Phone number"
                  onChange={this.handleNumber}
                  onKeyDown={this.handleSpaceBar}
                />
              </div>

              <div>
                <label className={labelClass}>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={this.onChange}
                  className={inputClass}
                  placeholder="Contact email address"
                />
              </div>

              <div>
                <label className={labelClass}>How Did You Hear About Us?</label>
                <select
                  className={inputClass}
                  name="source"
                  onChange={this.onChange}
                >
                  <option value="">Select</option>

                  <option value="google ads">Google Ads</option>
                  <option value="facebook">Facebook</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="flyer">Flyer</option>
                  <option value="billboard">Billboard</option>
                  <option value="mobile advert">Mobile Advert</option>
                  <option value="friend">Friend</option>
                  <option value="instagram">Instagram</option>
                  <option value="television">Television</option>
                  <option value="radio">Radio</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div>
                <label className={labelClass}>Country</label>
                <select
                  className={inputClass}
                  name="country"
                  onChange={this.onChange}
                  required
                >
                  <option required>Select Country</option>
                  {this.props.countries
                    .filter(
                      (item, index, i) =>
                        i.findIndex((t) => t.country === item.country) ===
                        index,
                    )
                    .map((country) => (
                      <option value={country.country === "Ghana" ? "gh" : "ng"}>
                        {country.country}
                      </option>
                    ))}
                </select>
              </div>

              <div>
                <label className={labelClass}>State</label>
                <select
                  className={inputClass}
                  name="state"
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  required
                >
                  <option>Select State</option>
                  {this.displayStateAndRegions()}
                </select>
              </div>
              <div>
                <label className={labelClass}>Select Plan</label>

                <select
                  className={inputClass}
                  value={this.state.planName}
                  onChange={this.handlePlanChange}
                >
                  <option value="turbo_connect">
                    Tizeti Turbo Connect - ₦76,000/month
                  </option>

                  <option value="turbo_connect_pro">
                    Tizeti Turbo Connect Pro - ₦120,000/month
                  </option>
                </select>
              </div>
              <div>
                <label className={labelClass}>Physical Address</label>
                <textarea
                  className={inputClass}
                  name="address"
                  value={address}
                  onChange={this.onChange}
                  placeholder="Physical address"
                  rows="5"
                />
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="terms"
                  checked={terms}
                  onChange={this.handleInputChange}
                />
                <label htmlFor="vehicle1">
                  By signing up, you agree to our{" "}
                  <a
                    href="http://wifi.com.ng/terms"
                    className="text-brand-teal no-underline cursor-pointer"
                  >
                    Terms and Conditions
                  </a>
                </label>
              </div>
              <div>
                {load ? (
                  <input
                    disabled={true}
                    className="w-full rounded-lg bg-brand-teal text-white py-2.5 font-semibold cursor-pointer"
                    value="Submitting..."
                    type="submit"
                  />
                ) : (
                  <motion.input
                    whileHover={isEnabled ? { scale: 1.02 } : {}}
                    whileTap={isEnabled ? { scale: 0.98 } : {}}
                    disabled={!isEnabled}
                    className="w-full rounded-lg bg-brand-teal text-white py-2.5 font-semibold cursor-pointer hover:bg-brand-teal-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    value="Proceed"
                    type="submit"
                  />
                )}
              </div>
            </div>
          </form>
        </motion.div>
        <ToastContainer />
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  load: state.signUp.load,
  countries: state.location.countries,
});

export default connect(mapStateToProps, { Turboaction, getCountries })(Turbos);
